import { Activity, Brain, Heart, Microscope, Scan, Waves } from "lucide-react";

const services = [
  { icon: Heart, title: "Doctor Consultation", price: "FREE", desc: "GP & specialist visits across all clinics" },
  { icon: Microscope, title: "Blood Tests", price: "10% OFF", desc: "CBC, lipid, thyroid, diabetes panels" },
  { icon: Scan, title: "CT Scan", price: "10% OFF", desc: "Multi-slice CT with rapid reports" },
  { icon: Brain, title: "MRI", price: "10% OFF", desc: "High-resolution MRI imaging" },
  { icon: Activity, title: "X-Ray", price: "10% OFF", desc: "Digital radiography at all centres" },
  { icon: Waves, title: "Sonography", price: "10% OFF", desc: "Ultrasound for full body & pregnancy" },
];

export const Services = () => {
  return (
    <section id="services" className="py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-12">
          <div className="max-w-2xl">
            <div className="text-xs font-semibold uppercase tracking-[0.18em] text-primary mb-3">
              What’s covered
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-foreground">
              Every service we run, <span className="text-gradient-aqua">discounted.</span>
            </h2>
          </div>
          <p className="text-sm text-muted-foreground sm:max-w-xs">
            Show your digital card at billing. The discount is applied instantly — no codes,
            no paperwork.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {services.map(({ icon: Icon, title, price, desc }) => (
            <div
              key={title}
              className="group relative overflow-hidden rounded-2xl border border-border/70 bg-card p-5 sm:p-6 hover:border-primary/30 hover:shadow-soft transition-all duration-300 flex items-center gap-4"
            >
              <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary group-hover:bg-gradient-primary group-hover:text-primary-foreground transition-colors">
                <Icon className="h-5 w-5" />
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-3">
                  <h3 className="font-display font-semibold text-base text-foreground truncate">
                    {title}
                  </h3>
                  <span
                    className={
                      "text-[10px] font-bold tracking-widest uppercase px-2 py-1 rounded-md " +
                      (price === "FREE"
                        ? "bg-success/12 text-success ring-1 ring-success/25"
                        : "bg-accent/12 text-accent ring-1 ring-accent/25")
                    }
                  >
                    {price}
                  </span>
                </div>
                <p className="mt-1 text-xs text-muted-foreground leading-relaxed">{desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
